// Recovered compiled webpack factory 24437. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    let { reason: t, children: r } = e;
    return r;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "BailoutToCSR", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    r(24553));
}
